module.exports = __webpack_public_path__ + "img/2005-24sata.f3ee4b96.jpg";